import Swiper from 'swiper';
import { Grid, Navigation } from 'swiper/modules';

function sliderCourses() {
  new Swiper('.swiper-courses', {
    modules: [Navigation, Grid],
    spaceBetween: 8,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      600: {
        spaceBetween: 8,
        slidesPerView: 2,
      },
      1110: {
        spaceBetween: 32,
        slidesPerView: 3,
      }
    }
  });
}
sliderCourses();